<template>
  <div class="dass-total-bonus-with-balance">
    <div class="dass-card-container">
      <div class="dass-card-content">
        <div class="dass-card-icon-label q-mr-md">          
          <q-icon name="mdi-cash-multiple" size="50px" class="q-pb-md" color="black" />
          <h3 class="q-mt-xl">{{$t('dass.shoppingVoucherBalance')}}</h3>
        </div>
        <h2><b>{{ 'R$ ' + total.toFixed(2) }}</b></h2> 
        <div class="dass-container-buttons">
          <dass-button class="dass-buttons-wallet" :class="this.isSafari ? `dass-button-primary-${this.brandName} button` : 'button'" variant="primary" type="button" @click="showModalGoShopping">
            {{ $t('dass.goShopping') }}            
          </dass-button>  
          <dass-button class="dass-buttons-wallet" :class="this.isSafari ? `dass-button-primary-${this.brandName} button` : 'button'" variant="secondary" type="button" @click="showModalExchange">
            {{ $t('dass.refundAmount') }}            
          </dass-button>           
        </div>
      </div>  
    </div>  
  </div>
</template>

<script>
import { useIsSafari } from '@/composables/useIsSafari'
export default {
  name: 'BonusBalances',
  props: {
    balanceAvailable: {
      type: Number,
      default: 0
    }
  },
setup() {
    const { isSafari, brandName } = useIsSafari()   
    return {
      isSafari,
      brandName      
    }     
  },
  data() {
    return {      
    }
  },
  computed: {
    total() {
      return this.balanceAvailable
    }
  },
  methods: {
    showModalExchange() {
      this.$emit('showModalExchange')
    },
    showModalGoShopping() {
      this.$emit('showModalGoShopping')
    }
  }
}

</script>

<style lang="scss" scoped>
.dass-total-bonus-with-balance {  
  flex: 1;
  .dass-card-container { 
    display: flex;
    align-items: center;
    min-height: 12rem;  
    border: var(--border-card);  
    border-radius: var(--border-radius-card);
  }
  .dass-card-content { 
    display: flex;     
    width: 100%;  
    align-items: center; 
    justify-content:  space-around;    
    flex-wrap: wrap;
    padding: var(--space);
    gap: var(--space);
    .dass-card-icon-label {
      display: flex;
      flex-direction: column;
      align-items: center;      
    }
    h3 {
      margin: 0;
      text-align: center;
    }
    .dass-container-buttons {
      display: flex;
      flex-direction: column;
      gap: var(--space);
    }    
    .dass-button-estorno {
      background-color: #FF0000; 
      padding: 10px 20px; 
      border-radius: 5px; 
      cursor: pointer; 
      transition: background-color 0.3s ease; 
      box-shadow: 0 0 0 0 rgba(46, 204, 113, 0.5);
      &:hover {
        animation: pulse-text 1.5s infinite;
        color: #fff;
      }     
    }
    @keyframes pulse-text {
      0% {
        box-shadow: 0 0 0 0 rgba(46, 204, 113, 0.5);        
      }
      70% {
        box-shadow: 0 0 0 10px rgba(46, 204, 113, 0);        
      }
      100% {
        box-shadow: 0 0 0 0 rgba(46, 204, 113, 0);        
      }
    }
  }
}

</style>